<template>
    <div class="distribution-card">
        <DoughnutChart
            :values="values"
            :colors="colors"
            :size="size"
            :cutout="cutout"
            :circumference="circumference"
            :rotation="rotation"
            :border-radius="borderRadius"
            :spacing="spacing"
            :center-label="centerLabel"
            :center-label-style="centerLabelStyle"
        />
        <div v-if="label" class="type-label">{{ label }}</div>
    </div>
</template>

<script setup>
import DoughnutChart from './DoughnutChart.vue';

const props = defineProps({
    values: {
        type: Array,
        required: true,
    },
    colors: {
        type: Array,
        default: () => ['#EBB6B7', '#6387fa'],
    },
    size: {
        type: Number,
        default: 60,
    },
    cutout: {
        type: String,
        default: '65%',
    },
    circumference: {
        type: Number,
        default: 360,
    },
    rotation: {
        type: Number,
        default: 0,
    },
    borderRadius: {
        type: Number,
        default: 2,
    },
    spacing: {
        type: Number,
        default: 2,
    },
    centerLabel: {
        type: [String, Number],
        default: null,
    },
    centerLabelStyle: {
        type: Object,
        default: () => ({
            color: '#EBB6B7',
            fontSize: '20px',
            fontWeight: '700',
            lineHeight: '12px',
        }),
    },
    label: {
        type: String,
        default: null,
    },
});
</script>

<style scoped>
.distribution-card {
    background: #f5f7fa;
    border-radius: 8px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.circle-graph {
    font-weight: 700;
    font-size: 11px;
}

.type-label {
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 500;
    color: #222;
    background: #fff;
    border-radius: 16px;
    padding: 1px 20px;
    display: block;
    width: 100%;
    text-align: center;
    margin-top: 0.25rem;
}

.type-label-skeleton {
    width: 80%;
    height: 1.25rem;
    border-radius: 16px;
    margin-top: 0.25rem;
    background: #fff;
}

:deep(.skeleton-loader) {
    background: #f5f7fa;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    text-align: center;
}

.chart-wrapper {
    display: inline-block;
}
</style>
